var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38272 1.7555C7.59605 1.19283 8.40338 1.19283 8.61738 1.7555L9.99738 5.57816C10.0455 5.70269 10.1303 5.80968 10.2405 5.88503C10.3507 5.96037 10.4812 6.00051 10.6147 6.00016H14.0061C14.6327 6.00016 14.9061 6.78016 14.4134 7.16216L12.0001 9.3335C11.8919 9.4166 11.8129 9.53181 11.7744 9.6626C11.7358 9.79339 11.7397 9.93303 11.7854 10.0615L12.6667 13.7968C12.8814 14.3968 12.1867 14.9122 11.6614 14.5428L8.38338 12.4628C8.27113 12.3839 8.13726 12.3416 8.00005 12.3416C7.86284 12.3416 7.72898 12.3839 7.61672 12.4628L4.33872 14.5428C3.81405 14.9122 3.11872 14.3962 3.33338 13.7968L4.21472 10.0615C4.26044 9.93303 4.26429 9.79339 4.22572 9.6626C4.18716 9.53181 4.10816 9.4166 4.00005 9.3335L1.58672 7.16216C1.09338 6.78016 1.36805 6.00016 1.99338 6.00016H5.38472C5.51825 6.00061 5.64876 5.9605 5.759 5.88514C5.86923 5.80979 5.95399 5.70274 6.00205 5.57816L7.38205 1.7555H7.38272Z",
    fill: "#FFDF37",
    stroke: "#FFDF37",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.0e3791783d58327bbe13635db703911b.svg";
export { ForwardRef as ReactComponent };